import {
  alwaysStructure,
  anonymousStructure,
  authorizedStructure,
  unAuthorizedStructure,
} from "_core/AppRoutes";
import { generateRoutes } from "_helpers";
import {
  useAuthUser,
  useInit,
  useMainStore,
  useNewVersion,
  useSanitizeRoutes,
  useSocialSignIn,
} from "_hooks";
import { AppAnimatePage, AppContentView, AppLoader, Layout } from "_lib";
import { useMemo } from "react";
import { useRoutes } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";
import { routesConfig } from "_core/AppRoutes/routeConfig";

const AppLayout = () => {
  const { socialSignInModalContextHolder } = useSocialSignIn();
  const { newVersionContextHolder } = useNewVersion();

  const {
    main: { redirectPath, onboardingCheckPending },
  } = useMainStore();

  const { isAuthenticated } = useAuthUser();

  useInit();
  const { sanitizeRoutes } = useSanitizeRoutes();

  const generatedRoutes = useMemo(() => {
    return generateRoutes({
      isAuthenticated,
      authorizedStructure,
      unAuthorizedStructure: { ...unAuthorizedStructure, redirectPath },
      anonymousStructure,
      alwaysStructure,
    }).map((route) => ({
      ...route,
      element: (
        <AppAnimatePage
          path={route?.path}
          noAnimation={route?.path?.includes("*")}
        >
          {route?.element}
        </AppAnimatePage>
      ),
      caseSensitive: true,
    }));
  }, [isAuthenticated, redirectPath]);

  const routes = useRoutes(sanitizeRoutes(generatedRoutes));

  if (isAuthenticated && onboardingCheckPending) {
    return <AppLoader position="fixed" height="100vh" />;
  }

  return (
    <>
      {isAuthenticated ? (
        <Layout routes={routes} routesConfig={routesConfig} />
      ) : (
        <AuthWrapper>
          <AppContentView routes={routes} />
        </AuthWrapper>
      )}
      {socialSignInModalContextHolder}
      <span key="new-version-modal-holder">{newVersionContextHolder}</span>
    </>
  );
};

export default AppLayout;
